import React from 'react';
import { Link } from 'react-router-dom';

// project-imports
import ScrollTopButton from './ScrollTopButton';
import StencilBox from '../../components/stencils/StencilBox';

const FooterOneStencil = () => {

    return (
        <>
            <footer className="eduvibe-footer-two edu-footer-with-cta eduvibe-footer-stencil-bg">
                <div className="edu-cta-area cta-with-overlay">
                    <div className="container">
                        <div className="row g-5">
                            <div className="col-lg-6">
                                <div className="call-action-style-1 bg-stencil-newsletter radius-small">
                                    <div className="inner">
                                        <div className="row align-items-center">
                                            <div className="col-12 col-sm-6">
                                                <div className="content">
                                                    <div className="section-title text-white">
                                                        <span className="pre-title">
                                                            <StencilBox
                                                                height="18px"
                                                                width="100%"
                                                                borderRadius="2px"
                                                                backgroundColor="#EEF1F6" />
                                                        </span>
                                                        <h5 className="title">
                                                            <StencilBox
                                                                height="108px"
                                                                width="100%"
                                                                borderRadius="2px"
                                                                backgroundColor="#EEF1F6" />
                                                        </h5>
                                                    </div>
                                                    <div className="read-more-btn mt--30">
                                                        <a className="edu-btn btn-medium btn-white pr--0 pl--0">
                                                            <StencilBox
                                                                height="100%"
                                                                width="155.38px"
                                                                borderRadius="5px"
                                                                backgroundColor="#EEF1F6" />

                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 d-none d-sm-block">
                                                <div className="thumbnail d-flex justify-content-center">
                                                    <StencilBox
                                                        className="main-img"
                                                        height="185px"
                                                        width="185px"
                                                        borderRadius="100%"
                                                        backgroundColor="#EEF1F6" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="call-action-style-1 box-layout radius-small bg-stencil-newsletter">
                                    <div className="inner">
                                        <div className="content">
                                            <div className="section-title text-white">
                                                <span className="pre-title">
                                                    <StencilBox
                                                        height="18px"
                                                        width="100%"
                                                        borderRadius="2px"
                                                        backgroundColor="#EEF1F6" />
                                                </span>
                                                <h5 className="title">
                                                    <StencilBox
                                                        height="72px"
                                                        width="100%"
                                                        borderRadius="2px"
                                                        backgroundColor="#EEF1F6" />
                                                </h5>
                                            </div>
                                            <div className="newsletter-form-box">
                                                <div className="newsletter-style-2">
                                                    <form action="#">
                                                        <div className="mt--30">
                                                            <Link className="edu-btn btn-medium btn-dark mb-0 pr--0 pl--0 bg-transparent" >
                                                                <StencilBox
                                                                    height="100%"
                                                                    width="155.38px"
                                                                    borderRadius="5px"
                                                                    backgroundColor="#EEF1F6" />

                                                            </Link>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="eduvibe-footer-one eduvibe-footer-stencil-bg edu-footer footer-style-default">

                    <div className="footer-top">
                        <div className="container eduvibe-animated-shape">
                            <div className="row g-5">
                                <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                                    <div className="edu-footer-widget">
                                        <div className="logo d-flex mr--20 mb--10">
                                            <StencilBox
                                                className="logo-light"
                                                height="160px"
                                                width="160px"
                                                borderRadius="100%"
                                                backgroundColor="#EEF1F6"
                                            />
                                        </div>
                                        <ul className="social-share">
                                            <li>
                                                <a><StencilBox
                                                    // className="mb--20"
                                                    height="100%"
                                                    width="100%"
                                                    borderRadius="5px"
                                                    backgroundColor="#EEF1F6" />
                                                </a></li>
                                            <li>
                                                <a><StencilBox
                                                    // className="mb--20"
                                                    height="100%"
                                                    width="100%"
                                                    borderRadius="5px"
                                                    backgroundColor="#EEF1F6" />
                                                </a></li>
                                            <li>
                                                <a><StencilBox
                                                    // className="mb--20"
                                                    height="100%"
                                                    width="100%"
                                                    borderRadius="5px"
                                                    backgroundColor="#EEF1F6" />
                                                </a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                    <div className="edu-footer-widget explore-widget">
                                        <StencilBox
                                            className="mb--20"
                                            height="36px"
                                            width="215px"
                                            backgroundColor="#EEF1F6"
                                        />
                                        <div className="inner">
                                            <ul className="footer-link link-hover">
                                                <li><Link className="d-flex">
                                                    <StencilBox
                                                        className="mr--10"
                                                        height="15px"
                                                        width="15px"
                                                        borderRadius="100%"
                                                        backgroundColor="#EEF1F6"
                                                    />
                                                    <StencilBox
                                                        height="17px"
                                                        width="120px"
                                                        backgroundColor="#EEF1F6"
                                                    />
                                                </Link></li>
                                                {/* BLOGS WE WILL RELEASE IN NEXT VERSION  Start*/}
                                                <li><Link className="d-flex">
                                                    <StencilBox
                                                        className="mr--10"
                                                        height="15px"
                                                        width="15px"
                                                        borderRadius="100%"
                                                        backgroundColor="#EEF1F6"
                                                    />
                                                    <StencilBox
                                                        height="17px"
                                                        width="120px"
                                                        backgroundColor="#EEF1F6"
                                                    />
                                                </Link></li>
                                                {/* BLOGS WE WILL RELEASE IN NEXT VERSION End*/}
                                                <li><Link className="d-flex">
                                                    <StencilBox
                                                        className="mr--10"
                                                        height="15px"
                                                        width="15px"
                                                        borderRadius="100%"
                                                        backgroundColor="#EEF1F6"
                                                    />
                                                    <StencilBox
                                                        height="17px"
                                                        width="120px"
                                                        backgroundColor="#EEF1F6"
                                                    />
                                                </Link></li>
                                                <li><Link className="d-flex">
                                                    <StencilBox
                                                        className="mr--10"
                                                        height="15px"
                                                        width="15px"
                                                        borderRadius="100%"
                                                        backgroundColor="#EEF1F6"
                                                    />
                                                    <StencilBox
                                                        height="17px"
                                                        width="120px"
                                                        backgroundColor="#EEF1F6"
                                                    />
                                                </Link></li>
                                                <li><Link className="d-flex">
                                                    <StencilBox
                                                        className="mr--10"
                                                        height="15px"
                                                        width="15px"
                                                        borderRadius="100%"
                                                        backgroundColor="#EEF1F6"
                                                    />
                                                    <StencilBox
                                                        height="17px"
                                                        width="120px"
                                                        backgroundColor="#EEF1F6"
                                                    />
                                                </Link></li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                    <div className="edu-footer-widget quick-link-widget">
                                        <StencilBox
                                            className="mb--20"
                                            height="36px"
                                            width="215px"
                                            backgroundColor="#EEF1F6"
                                        />
                                        <div className="inner">
                                            <ul className="footer-link link-hover">
                                                <li><Link className="d-flex">
                                                    <StencilBox
                                                        className="mr--10"
                                                        height="15px"
                                                        width="15px"
                                                        borderRadius="100%"
                                                        backgroundColor="#EEF1F6"
                                                    />
                                                    <StencilBox
                                                        height="17px"
                                                        width="120px"
                                                        backgroundColor="#EEF1F6"
                                                    />
                                                </Link></li>
                                                <li><Link className="d-flex">
                                                    <StencilBox
                                                        className="mr--10"
                                                        height="15px"
                                                        width="15px"
                                                        borderRadius="100%"
                                                        backgroundColor="#EEF1F6"
                                                    />
                                                    <StencilBox
                                                        height="17px"
                                                        width="120px"
                                                        backgroundColor="#EEF1F6"
                                                    />
                                                </Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                    <div className="edu-footer-widget">
                                        <StencilBox
                                            className="mb--20"
                                            height="36px"
                                            width="215px"
                                            backgroundColor="#EEF1F6"
                                        />
                                        <div className="inner">
                                            <div className="widget-information">
                                                <ul className="information-list">
                                                    <li>
                                                        <StencilBox
                                                            className="mr--15 mt--5"
                                                            height="15px"
                                                            width="15px"
                                                            borderRadius="100%"
                                                            backgroundColor="#EEF1F6"
                                                        />
                                                        <StencilBox
                                                            height="30px"
                                                            width="150px"
                                                            backgroundColor="#EEF1F6"
                                                        />
                                                    </li>
                                                    <li>
                                                        <StencilBox
                                                            className="mr--15"
                                                            height="15px"
                                                            width="15px"
                                                            borderRadius="100%"
                                                            backgroundColor="#EEF1F6"
                                                        />
                                                        <a>
                                                            <StencilBox
                                                                height="100%"
                                                                width="150px"
                                                                backgroundColor="#EEF1F6"
                                                            />
                                                        </a></li>
                                                    <li>
                                                        <StencilBox
                                                            className="mr--15"
                                                            height="15px"
                                                            width="15px"
                                                            borderRadius="100%"
                                                            backgroundColor="#EEF1F6"
                                                        />
                                                        <a>
                                                            <StencilBox
                                                                height="100%"
                                                                width="150px"
                                                                backgroundColor="#EEF1F6"
                                                            />
                                                        </a></li>
                                                    <li>
                                                        <StencilBox
                                                            className="mr--15"
                                                            height="15px"
                                                            width="15px"
                                                            borderRadius="100%"
                                                            backgroundColor="#EEF1F6"
                                                        />
                                                        <a>
                                                            <StencilBox
                                                                height="100%"
                                                                width="150px"
                                                                backgroundColor="#EEF1F6"
                                                            />
                                                        </a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="copyright-area copyright-default">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="inner text-center">
                                        <p><StencilBox
                                            height="17px"
                                            width="100%"
                                            backgroundColor="#EEF1F6"
                                        /></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer >
            <ScrollTopButton />
        </>
    )
}

export default FooterOneStencil;